import { ReportLoading } from './ReportLoading';

export default ReportLoading;
